import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Labelling } from "./labelling.entity";
@Entity('labelling_samples')
export class LabellingSamples {
    @PrimaryGeneratedColumn('increment', {
        name: 'labelling_samples_id',
    })
    labellingSamplesId: number;

    @Column('int', {
        name: 'labelling_id'
    })
    labellingId: number

    @Column('datetime', {
        nullable: false,
        name: 'labelling_time',
    })
    labellingTime: Date;


    @Column("boolean", {
        nullable: false,
        default: true,
        name: "shrimps_label"
    })
    shrimpsLabel: boolean;


    @Column("boolean", {
        nullable: false,
        default: true,
        name: "allergen_label"
    })
    allergenLabel: boolean;

    @Column('varchar', {
        nullable: false,
        name: 'certification_logo',
    })
    certificationLogo: string;

    @Column('varchar', {
        nullable: false,
        name: 'remarks',
    })
    remarks: string;

    @Column('varchar', {
        nullable: false,
        name: 'corrective_action',
    })
    correctiveAction: string;

    @Column('varchar', {
        nullable: false,
        name: 'checked_by',
    })
    checkedBy: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })

    versionFlag: number;

    @ManyToOne(type => Labelling, rmEval => rmEval.labellingSamplesInfo, { nullable: false })
    @JoinColumn({ name: 'labelling_id' })
    labellingInfo: Labelling;
}